import "./NewTreeButton.css";

interface NewTreeButtonProps {
  onClick?: () => void;
  className?: string;
}

export default function NewTreeButton({ onClick, className = "" }: NewTreeButtonProps) {
  return (
    <button type="button" className={`new-tree-button ${className}`.trim()} onClick={onClick}>
      <svg viewBox="0 0 20 20" width="14" height="14" aria-hidden="true">
        <path d="M10 4 V16 M4 10 H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
      New tree
    </button>
  );
}
